/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useContext } from "react";
import { Button, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import MapPropsContext from "../MapPropsContext";
import { ACTIONS as ACTIONS_VIEWSTATE } from "../reducerViewState";
import { TI_MAP_MINUS_BUTTON, TI_MAP_PLUS_BUTTON } from "../../../Constants";

const WidgetZoom = ({ style }) => {
  const { dispatchViewState, viewState } = useContext(MapPropsContext);

  const { isDisableZoomIn, isDisableZoomOut } = viewState;

  const zoomIn = useCallback(() => {
    dispatchViewState({
      type: ACTIONS_VIEWSTATE.ZOOM_IN,
    });
  }, []);

  const zoomOut = useCallback(() => {
    dispatchViewState({
      type: ACTIONS_VIEWSTATE.ZOOM_OUT,
    });
  }, []);

  return (
    <div style={{ ...style }}>
      <Tooltip title={"지도 확대"} placement="left">
        <Button
          shape={"circle"}
          aria-label="지도 확대"
          disabled={isDisableZoomIn}
          onClick={() => zoomIn()}
          style={{ display: "block", marginBottom: 1 }}
          tabIndex={TI_MAP_PLUS_BUTTON}
        >
          <FontAwesomeIcon icon={faPlus} />
        </Button>
      </Tooltip>
      <Tooltip title={"지도 축소"} placement="left">
        <Button
          shape={"circle"}
          aria-label="지도 축소"
          disabled={isDisableZoomOut}
          onClick={() => zoomOut()}
          tabIndex={TI_MAP_MINUS_BUTTON}
        >
          <FontAwesomeIcon icon={faMinus} />
        </Button>
      </Tooltip>
    </div>
  );
};

export default WidgetZoom;
